var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "#1D2933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7026 6.76087C17.4315 6.76087 18.833 5.35933 18.833 3.63043C18.833 1.90154 17.4315 0.5 15.7026 0.5C13.9737 0.5 12.5721 1.90154 12.5721 3.63043C12.5721 3.78496 12.5833 3.93688 12.605 4.08541L6.1856 7.29509C5.61844 6.72352 4.83227 6.36957 3.96344 6.36957C2.23455 6.36957 0.833008 7.77111 0.833008 9.5C0.833008 11.2289 2.23455 12.6304 3.96344 12.6304C4.83234 12.6304 5.61856 12.2764 6.18574 11.7048L12.605 14.9144C12.5833 15.063 12.5721 15.215 12.5721 15.3696C12.5721 17.0985 13.9737 18.5 15.7026 18.5C17.4315 18.5 18.833 17.0985 18.833 15.3696C18.833 13.6407 17.4315 12.2391 15.7026 12.2391C14.8337 12.2391 14.0476 12.5931 13.4804 13.1647L7.06105 9.95498C7.08268 9.80644 7.09388 9.65453 7.09388 9.5C7.09388 9.3454 7.08267 9.19343 7.06103 9.04484L13.4803 5.83521C14.0475 6.40686 14.8337 6.76087 15.7026 6.76087Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.f5a3a1ede35a2f75e3047b6b64b6991e.svg";
export { ForwardRef as ReactComponent };